(function (global, factory) {
  module.exports = factory(
    require('./utility/i18n.js'),
    require('./storage.jsx'),
    require('./utility/overseer.js')
  );
}(this, function (i18n, storage, overseer) {
    var __js = i18n.__js,
        SHOW = true,
        HIDE = false,
        getGlobal = storage.getFhtGlobal,
        setGlobal = storage.setFhtGlobal;

    function DisplayParams(settings) {
        var HIDE      = false,
            _settings = settings || {};
        return {
            name      : _settings.name || HIDE,
            age       : _settings.age || HIDE,
            note      : _settings.note || HIDE,
            conditions: _settings.conditions || HIDE,
            tests     : _settings.tests || HIDE
        };
    }

    var heightConstants = {
        CM_IN_INCH : 2.54,
        INCH_IN_FT : 12,
        MM_IN_CM   : 10,
        FOOT       : 'ft',
        CENTIMETER : 'cm',
        INCH       : 'in'
    };

    var weightConstants = {
        LBS_IN_KG : 2.20462,
        GM_IN_KG  : 1000,
        POUNDS    : 'lbs',
        KILOGRAM  : 'kg'
    };

    var units = {
        METRIC   : 'metric',
        IMPERIAL : 'imperial'
    };

    var weightConverter = {
        lbsToKg : function lbsToKg(value) { return Math.round(parseInt(value) / weightConstants.LBS_IN_KG) || 0; },
        lbsToGm : function lbsToGm(value) { return Math.round(parseInt(value) / weightConstants.LBS_IN_KG * weightConstants.GM_IN_KG) || 0; },
        kgToLbs : function kgToLbs(value) { return Math.round(parseInt(value) * weightConstants.LBS_IN_KG) || 0; },
        gmToLbs : function gmToLbs(value) { return Math.round(parseInt(value) * weightConstants.LBS_IN_KG / weightConstants.GM_IN_KG) || 0; },
        kgToGm  : function kgToGm(value) { return Math.round(parseInt(value) * weightConstants.GM_IN_KG) || 0; },
        gmToKg  : function gmToKg(value) { return Math.round(parseInt(value) / weightConstants.GM_IN_KG) || 0; }
    };

    var heightConverter = {
        inToCm : function inToCm(value) { return Math.round(parseInt(value) * heightConstants.CM_IN_INCH) || 0; },
        inToMm : function inToMm(value) { return Math.round(parseInt(value) * heightConstants.CM_IN_INCH * heightConstants.MM_IN_CM) || 0; },
        cmToIn : function cmToIn(value) { return Math.round(parseInt(value) / heightConstants.CM_IN_INCH) || 0; },
        inToFt : function inToFt(value) { return Math.floor(parseInt(value) / heightConstants.INCH_IN_FT) || 0; },
        ftToIn : function ftToIn(value) { return Math.round(parseInt(value) * heightConstants.INCH_IN_FT) || 0; },
        mmToIn : function mmToIn(value) { return Math.round(parseInt(value) / heightConstants.MM_IN_CM / heightConstants.CM_IN_INCH) || 0; },
        mmToCm : function mmToCm(value) { return Math.round(parseInt(value) / heightConstants.MM_IN_CM) || 0; },
        cmToMm : function cmToMm(value) { return Math.round(parseInt(value) * heightConstants.MM_IN_CM) || 0; }
    };

    var displayParamsPresets = {
        none  : DisplayParams(/* hide all */),
        less  : DisplayParams({
            name: SHOW,
            age : SHOW
        }),
        more  : DisplayParams({
            name      : SHOW,
            age       : SHOW,
            note      : HIDE,
            conditions: SHOW,
            tests     : SHOW
        }),
        all   : DisplayParams({
            name      : SHOW,
            age       : SHOW,
            note      : SHOW,
            conditions: SHOW,
            tests     : SHOW
        }),
        custom: DisplayParams({
            name      : SHOW,
            age       : SHOW,
            note      : SHOW,
            conditions: SHOW,
            tests     : SHOW
        })
    };

    /* export */
    function escapeHtml(text) {
        return text
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#039;");
    }

    var keyCode = {
        BACKSPACE      : 8,
        COMMA          : 188,
        DELETE         : 46,
        DOWN           : 40,
        END            : 35,
        ENTER          : 13,
        ESCAPE         : 27,
        HOME           : 36,
        LEFT           : 37,
        NUMPAD_ADD     : 107,
        NUMPAD_DECIMAL : 110,
        NUMPAD_DIVIDE  : 111,
        NUMPAD_ENTER   : 108,
        NUMPAD_MULTIPLY: 106,
        NUMPAD_SUBTRACT: 109,
        PAGE_DOWN      : 34,
        PAGE_UP        : 33,
        PERIOD         : 190,
        RIGHT          : 39,
        SPACE          : 32,
        TAB            : 9,
        UP             : 38
    };


    function microtime(get_as_float) {
        //  discuss at: http://phpjs.org/functions/microtime/
        // original by: Paulo Freitas
        //   example 1: timeStamp = microtime(true);
        //   example 1: timeStamp > 1000000000 && timeStamp < 2000000000
        //   returns 1: true

        var now = new Date()
                .getTime() / 1000;
        var s   = parseInt(now, 10);

        return (get_as_float) ? now : (Math.round((now - s) * 1000) / 1000) + ' ' + s;
    }


    //from model.person
    var Gender = {
        male   : 0,
        female : 1,
        unknown: 2
    };

    function Sibling(_type, _person){
        this.type = _type;
        this.person = _person;
    }

    var Fertilization = {
        0: __js("Normal"),
        1: __js("IVF"),
        2: __js("IVF with ICSI")
    };

    var PersonStatus = {
        alive: 0,
        dead:1,
        unknown:2,
        abortion:3,
        alive_and_well:4,
        miscarriage:5,
        infertility:6,
        nochild:7,
        terminator:8
    };

    var markedByLbl = {
        "0": __js("N/A"),
        "1": "+",
        "2": "-",
        "3": "*"
    };

    var SiblingType = {
        normal: 0,
        twin: 1,
        twin_identical: 2,
        twin_unknown: 3
    };

    var RelationType = {
        parents: "Parents",
        father: "Father",
        mother: "Mother",
        child_male: "Son",
        child_female: "Daughter",
        child_unknown: "Child",
        child_miscarriage: "Miscarriage",
        child_abortion: "Abortion",
        child_twins: "Twins",
        child_twins_identical: "Identical twins",
        child_nochild: "No child",
        child_infertility: "Infertility",
        spouse_male: "Husband",
        spouse_female: "Wife",
        exspouse_male: "Ex-husband",
        exspouse_female: "Ex-wife",
        sibling_male: "Brother",
        sibling_female: "Sister",
        sibling: "Sibling",
        donor_male: "Donor Male",
        donor_female: "Donor Female",
        surrogate: "Surrogate",
        terminator: "Terminator"
    };


    //from model.condition
    var ConditionMode = {
        Color: "0",
        BW: "1"
    };

    var ConditionsColors = {
        "0": {
            "0": '#c00000',
            "1": '#00b050',
            "2": '#7f7f7f',
            "3": '#938953',
            "4": '#00b0f0',
            "5": '#ffc000',
            "6": '#7030a0',
            "7": '#31859b',
            "8": '#e36c09',
            "9": '#366092'
        },
        "1": {
            "0": '0px 0px',
            "1": '0px -100px',
            "2": '0px -200px',
            "3": '-152px 0px',
            "4": '-152px -100px',
            "5": '-152px -200px',
            "6": '-201px -1px',
            "7": '-202px -99px',
            "8": '-202px -199px',
            "9": '-300px -1px'
        }
    };

    var CondTypes = [
        "",
        __js("Clinical Diagnosis"),
        __js("Confirmed Moleculary"),
        __js("Confirmed Cytogenetically"),
        __js("Confirmed Biochemically (analyze)"),
        __js("Confirmed Enzymatically")
    ];

    var availableStatuses = ["affected", "carrier", "unknown"];

    var translatedStatuses = [__js("affected"), __js("carrier"), __js("unknown")];

    var anthology_mapping = {
        "SNOMEDCT": "SNOMED",
        "GTR": __js("All"),
        "RiskTests": __js("FOR RISK")
    };

    function map_anthology(anth) {
        if ( anthology_mapping[anth] ) {
            return anthology_mapping[anth];
        }
        return anth;
    }

  function getCookie(name) {
    var cookieValue = null;
    if (document.cookie && document.cookie != '') {
      var cookies = document.cookie.split(';');
      for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i].trim();
        // Does this cookie string begin with the name we want?
        if (cookie.substring(0, name.length + 1) == (name + '=')) {
          cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
          break;
        }
      }
    }
    return cookieValue;
  }

  function setCookie(name, value, options) {
    options = options || {};

    var expires = options.expires;

    if (typeof expires == "number" && expires) {
      var d = new Date();
      d.setTime(d.getTime() + expires * 1000);
      expires = options.expires = d;
    }
    if (expires && expires.toUTCString) {
      options.expires = expires.toUTCString();
    }

    var updatedCookie = `${name}=${encodeURIComponent(value)}`;

    for (var propName in options) {
      updatedCookie += "; " + propName;
      var propValue = options[propName];
      if (propValue !== true) {
        updatedCookie += "=" + propValue;
      }
    }

    document.cookie = updatedCookie;
  }

    function setRATermsOfUseShown() {
        storage.setUserFlag(
            getGlobal('userEmail'),
            'FHTRAShown', true);
    }

    function isRATermsOfUseShown() {
        return storage.getUserFlag(
            getGlobal('userEmail'),
            'FHTRAShown'
        );
    }

    function isRiskDisabledPopupHidden() {
        return getGlobal(
            'noRiskDisabledPopup'
        ) || storage.getUserFlag(
            getGlobal('userEmail'),
            'RiskDisabledViewed'
        );
    }

    function setRiskDisabledViewed() {
        storage.setUserFlag(
            getGlobal('userEmail'),
            'RiskDisabledViewed', true);
    }

    function gettingStartedDisplayed(asEvent) {
        if (asEvent){
            setGlobal('showGSOnStartup', false);
            showRisksDisabledPopover();
        } else {
            // as flag
            return getGlobal('showGSOnStartup')
        }
    }

    function showRisksDisabledPopover() {
        var hidden = isRiskDisabledPopupHidden();
        setTimeout(function () {
            hidden || gettingStartedDisplayed() || overseer.ask('react.app.store', 'dispatch',
                { type: 'POPOVER_SHOW', name: 'RisksDisabledPopover' });
        }, 2000);
    }

    function ieVersion(){
        var ua = window.navigator.userAgent.toLocaleLowerCase(),
            _isEdge     =  /edge/.test(ua),
            _isTrident  =  /trident/.test(ua),
            _isMSIE     =  /msie/.test(ua),
            isIE = _isEdge || _isTrident || _isMSIE,
            ieEngine;

        if (_isMSIE) {
            ieEngine = 'msie/';
        } else if (_isTrident) {
            ieEngine = 'trident/';
        } else if (_isEdge) {
            ieEngine = 'edge/';
        }
        return isIE ? parseInt(ua.split(ieEngine)[1]) : false;
    }

    function isGCFInstalled() {
        return 'undefined' !== typeof window.externalHost;
    }

    function isWebKit(){
        return 'WebkitAppearance' in document.documentElement.style;
    }



    /* All code down here just initcode, no need to export */
    // Getting csrf token
    function csrfSafeMethod(method) {
        // these HTTP methods do not require CSRF protection
        return (/^(GET|HEAD|OPTIONS|TRACE)$/.test(method));
    }

    if ( 'undefined' !== typeof window ) {
        var jQuery = require('jquery');
        jQuery.ajaxSetup({
            beforeSend: function(xhr, settings) {
                var csrftoken = getCookie('csrftoken');
                if (!csrfSafeMethod(settings.type) && !this.crossDomain) {
                    xhr.setRequestHeader("x-csrftoken", csrftoken);
                }
            }
        });
    }

  return {
    displayParamsPresets: displayParamsPresets,
    escapeHtml          : escapeHtml,
    keyCode             : keyCode,
    heightConstants     : heightConstants,
    weightConstants     : weightConstants,
    units               : units,
    weightConverter     : weightConverter,
    heightConverter     : heightConverter,
    microtime           : microtime,

    getCookie           : getCookie,
    setCookie           : setCookie,

    Gender              : Gender,
    Sibling             : Sibling,
    Fertilization       : Fertilization,
    PersonStatus        : PersonStatus,
    markedByLbl         : markedByLbl,
    SiblingType         : SiblingType,
    RelationType        : RelationType,

    ConditionMode       : ConditionMode,
    ConditionsColors    : ConditionsColors,
    CondTypes           : CondTypes,
    map_anthology       : map_anthology,
    availableStatuses   : availableStatuses,
    translatedStatuses  : translatedStatuses,

    PersonRiskArray     : [],

    setGlobal               : storage.setFhtGlobal,
    getGlobal               : storage.getFhtGlobal,
    setRATermsOfUseShown    : setRATermsOfUseShown,
    gettingStartedDisplayed : gettingStartedDisplayed,
    showRisksDisabledPopover: showRisksDisabledPopover,
    isRATermsOfUseShown     : isRATermsOfUseShown,
    setRiskDisabledViewed   : setRiskDisabledViewed,
    isWebKit                : isWebKit,
    ieVersion               : ieVersion,
    isGCFInstalled          : isGCFInstalled
  }

}));

